export default status => {
  switch (status) {
    case 'EXPIRED':
      return '#FFE9E9';
    case 'ACTIVE':
      return '#C9FFEF';
    case 'INACTIVE':
      return '#FFE9E9';
    default:
      return '';
  }
};
